// Add your custom JS here.

// toggle menu visiblility
const toggleMenu = () => {
    if ( jQuery( ".menu #mega-menu-wrap-primary .mega-menu-toggle" ).hasClass("mega-menu-open") ) {
        jQuery( ".mega-menu-item" ).fadeOut(1000);        
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-item>a.mega-menu-link").fadeOut(1000);
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary > li.mega-menu-megamenu > ul.mega-sub-menu li.mega-menu-column > ul.mega-sub-menu > li.mega-menu-item > a.mega-menu-link").fadeOut(1000);
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary li.mega-menu-item > ul.mega-sub-menu").fadeOut(1000);
    }
    else {
        jQuery( ".mega-menu-item" ).fadeIn(1000);      
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-item>a.mega-menu-link").fadeIn(1000);
        
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary > li.mega-menu-megamenu > ul.mega-sub-menu li.mega-menu-column > ul.mega-sub-menu > li.mega-menu-item > a.mega-menu-link").fadeIn(1000);
        jQuery(".menu #mega-menu-wrap-primary #mega-menu-primary li.mega-menu-item > ul.mega-sub-menu").fadeIn(1000);  
    }
};

let widgetId = '0';
let regFormHeight = 0;
let loadedWidgets = [];
let resized = false;

const addQScript = () => {    
    let i = document.createElement("script");
    i.type = "text/javascript";
    i.async = true;
    i.src = "https://intakeq.com/js/widget.v2.min.js?1";
    document.head.appendChild(i);
    document.addEventListener("intakeqWidgetLoaded", function(e) {
        showForm();
    });
};

const setMaskHeight = () => {
    // get current height of intakeQ form
    let formHeight = jQuery("#" + widgetId).height();
    if (regFormHeight != formHeight) {
        regFormHeight = formHeight;
        let maskHeight = formHeight + 20;
        jQuery(".sp-mask").css("min-height", maskHeight + "px");
        console.log("intakeq-form height:", maskHeight);
    }
};

const showForm = () => {  
    console.log("showForm:", widgetId);  
    jQuery("#" + widgetId + ".intakeq-form").show();
    jQuery("#" + widgetId + ".intakeq-form").attr("style", "display: block");
    console.log("form heights - ", jQuery("#" + widgetId).height());
    let heightInterval = setInterval(setMaskHeight, 2000);
};

const loadWidget = (optionObj) => {
    if (optionObj.serviceId !== undefined) {
        window.intakeqw = [{
            id:"604788fa8bb5321550f42129",
            serviceId: optionObj.serviceId,
            elem: widgetId
        }];
    }
    else if (optionObj.packageId !== undefined) {
        window.intakeqw = [{
            id:"604788fa8bb5321550f42129",
            packageId: optionObj.packageId,
            elem: widgetId
        }];
    }
    if (optionObj.serviceId !== undefined || optionObj.packageId !== undefined) {
        addQScript();
        loadedWidgets.push(widgetId);
    }
};

// Add click events
jQuery( ".menu #mega-menu-wrap-primary .mega-menu-toggle" ).on( "click", function() {
    toggleMenu();
    /* this.classList.toggle( "active" ); */    
});

jQuery( ".home-link" ).on( "click", function() {
    if ( jQuery( ".menu #mega-menu-wrap-primary .mega-menu-toggle" ).hasClass("mega-menu-open") ) {
        toggleMenu(); 
    }
});

jQuery("#rmp_menu_trigger-87").on("click", function() {
    jQuery("#rmp_menu_trigger-87").toggleClass("clicked");
})

/* SLIDER */
/* SLIDER EVENTS */
const getSlider = () => {
    let sliderArr = document.getElementsByClassName("slider-pro");
    if (sliderArr != null && sliderArr.length > 0) {
        return sliderArr[0];
    }
    return null;
};
const sliderEvents = () => {
    let slider = getSlider();
    console.log("slider:", slider, );
    if (slider != null) {
        setTimeout(setSliderBtns, 500);
        slider.addEventListener( 'gotoSlideComplete', ( event ) => {
            console.log("index:", event.detail.index);
            setSliderBtns();
        });
    }
};
/* SLIDER BTNS POSITION */
const setSliderBtns = () => {
    let windowWidth = jQuery(window).width();
    console.log("windowWidth:",windowWidth);
    if (windowWidth < 768) {
        let sliderNextBtnArr = document.getElementsByClassName('sp-next-arrow');
        if (sliderNextBtnArr != null && sliderNextBtnArr.length > 0) {
            let sliderNextBtn = sliderNextBtnArr[0];
            sliderNextBtn.addEventListener( 'click', () => {
                console.log("next clicked");
                setTimeout(setSliderBtns, 500);
            });
            console.log("sliderNextBtn:", sliderNextBtn, sliderNextBtnArr);
        }
        let arrowTop = jQuery(".sp-arrows .sp-next-arrow").offset().top;
        let nextLeft = jQuery(".sp-arrows .sp-next-arrow").offset().left;
        jQuery(".sp-arrows .sp-previous-arrow").offset({top: arrowTop, left: 10});
        console.log("arrows offset:", jQuery(".sp-arrows .sp-next-arrow").offset(), "nextLeft:", nextLeft, jQuery(".sp-arrows .sp-previous-arrow").offset());
        if (nextLeft < windowWidth - 52) {
            let newNextLeft = windowWidth - 52;
            console.log("newNextLeft:", newNextLeft);
            jQuery(".sp-arrows .sp-next-arrow").offset({top: arrowTop, left: newNextLeft});
        }
        resized = true;
    }
    else {
            // if screen has been resized reload window
            if (resized) {
                location.reload();
            }
        }
};

/* if (jQuery(".slider-pro") != undefined && jQuery(".slider-pro").length > 0) {
    console.log("slider init");
    setTimeout(setSliderBtns, 500);
} */
/* BTNS */
/* jQuery(".sp-next-arrow").on( "click", function(event) {
    
}); */
jQuery(".appt-btn.iv-btn").on( "click", function(event) {
    event.preventDefault();
    jQuery(".blurb").hide();
    jQuery(".excerpt").hide();
    jQuery(".options").hide();
    jQuery(".appt-btn").hide();
    jQuery(".sp-buttons").hide();
    jQuery(".sp-horizontal .sp-arrows").hide();
    jQuery(".product-info-btn").show();
    jQuery(".intakeq-form").hide();
    let productId = jQuery(this).parents( ".product-info" ).attr("id");
    let optionObj = jQuery.parseJSON( jQuery(this).siblings(".options").val() );
    let optionPos = jQuery(this).parents( ".product-info" ).find("select[name='options'] option:selected").index() + 1;
    let siblingId = jQuery(this).siblings('.intakeq-form').attr("id");
    let widgetsDiv = jQuery(this).parents( ".product-info" ).find('.widgets-div').attr("id");
    widgetId = 'widget' + productId + '-' + optionPos;
    jQuery("#" + widgetId + ".intakeq-form").show();
    console.log("productId:", productId, "optionPos:", optionPos, "siblingId:", siblingId, "widgetsDiv:", widgetsDiv, "widgetId:", widgetId, jQuery(this).siblings("select[name='options'] option:selected"), jQuery(this).parents( ".product-info" ).find("select[name='options'] option:selected"));
    if (!loadedWidgets.includes(widgetId)) {
        loadWidget(optionObj);
    }
});
jQuery( ".appt-btn.office" ).on( "click", function(event) {
    event.preventDefault();
	let service = jQuery(this).data("service");
    let optionObj = jQuery.parseJSON( jQuery("#office").val() );    
    jQuery("#appt-boxes").hide();
    jQuery(".product-info-btn").show();
    jQuery("#widget-div").show();
    jQuery(".intakeq-form").hide();
    widgetId = service + "-office";
    jQuery("#" + widgetId + ".intakeq-form").show();
	console.log("office:", service, optionObj);
    if (!loadedWidgets.includes(widgetId)) {
        loadWidget(optionObj);
    }
});
jQuery( ".appt-btn.home" ).on( "click", function(event) {
    event.preventDefault();
	let service = jQuery(this).data("service");
    let optionObj = jQuery.parseJSON( jQuery("#home").val() );    
    jQuery("#appt-boxes").hide();
    jQuery(".product-info-btn").show();
    jQuery("#widget-div").show();
    jQuery(".intakeq-form").hide();
    widgetId = service + "-home";
    jQuery("#" + widgetId + ".intakeq-form").show();
	console.log("home:", service, optionObj);
    if (!loadedWidgets.includes(widgetId)) {
        loadWidget(optionObj);
    } 
});
jQuery( ".appt-btn.tele" ).on( "click", function(event) {
    event.preventDefault();
	let service = jQuery(this).data("service");
    let optionObj = jQuery.parseJSON( jQuery("#tele").val() );    
    jQuery("#appt-boxes").hide();
    jQuery(".product-info-btn").show();
    jQuery("#widget-div").show();
    jQuery(".intakeq-form").hide();
    widgetId = service + "-tele";
    jQuery("#" + widgetId + ".intakeq-form").show();
	console.log("tele:", service, optionObj);
    if (!loadedWidgets.includes(widgetId)) {
        loadWidget(optionObj);
    }
});
jQuery(".product-info-btn").on( "click", function(event) {
    event.preventDefault();
    jQuery(".blurb").show();
    jQuery(".excerpt").show();
    jQuery(".options").show();
    jQuery(".appt-btn").show();
    jQuery(".sp-buttons").show();
    jQuery(".sp-horizontal .sp-arrows").show();
    jQuery(".product-info-btn").hide();
    jQuery(".intakeq-form").hide();
    setMaskHeight();
})
jQuery(".product-info-btn.service-btn").on( "click", function(event) {
    event.preventDefault();       
    jQuery("#appt-boxes").show();
    jQuery(".product-info-btn").hide();
    jQuery("#widget-div").hide();
    setMaskHeight();
})

/* MENU */
const placeToggleButton = () => { let windowOffset = jQuery(window).scrollTop();
    if (windowOffset > 10) {
        jQuery("#rmp_menu_trigger-87").addClass("move-to-top");
        jQuery("#rmp_menu_trigger-87").removeClass("move-back-down");
      } else {
        if (jQuery("#rmp_menu_trigger-87").hasClass("move-to-top")) {
            jQuery("#rmp_menu_trigger-87").addClass("move-back-down");
            jQuery("#rmp_menu_trigger-87").removeClass("move-to-top");
        }
      }
};
jQuery(window).scroll(function() {
    placeToggleButton();
});

jQuery(function() {
    placeToggleButton();
    jQuery(".intakeq-form").hide();
    sliderEvents();
});
window.addEventListener('resize', function() {    
    console.log("slider resize");
    sliderEvents();
}, true);